
function getAddressItem(address, names, comma) {
    let addr = [],
        lastItem;
    for (let i = 0, len = names.length; i < len; i++) {
        let item = address[names[i]];
        if (item && lastItem !== item) {
            addr.push((lastItem = item));
        }
    }
    return addr.length ? addr.join(' ') + (comma === false ? '' : ', ') : '';
}

export function formatAddress(item) {
    let address = item.address,
        detailAddr =
            getAddressItem(address, ['houseNumber', 'street']) +
            getAddressItem(address, ['city']);
    return detailAddr
        ? decodeURIComponent(
            detailAddr +
            getAddressItem(address, ['state', 'postalCode'], false)
        )
        : null;
}
